import ModelSelect from '@/components/ExercisesContent/components/model-select/model-select.vue'
import ReportError from '@/components/ExercisesContent/components/report-error/report-error.vue'
import ExercisesSubtitles from '@/components/ExercisesSubtitles/ExercisesSubtitles.vue'
import GreContent from '@/components/ExercisesContent/components/gre-content/gre-content.vue'
import PracticeContent from '@/components/ExercisesContent/components/practice-content/practice-content.vue'
// import WalkmanPracticeContent from '@/components/ExercisesContent/components/practice-content/practice-content-walkman.vue'
import PassDialog from '@/components/ExercisesContent/components/pass-dialog.vue'
import AskQuestions from '@/components/ExercisesTabs/components/ask-questions/ask-questions.vue'
import VideoDialog from '@/components/VideoDialog/VideoDialog.vue'
import SubmutBtn from './components/submitBtn'
import Audio from '@/components/Audio/Audio.vue'
import Button from '@/components/button'
import Func from './components/practice-content/func'
import VipCount from './components/vipCount'
import LeadWay from './leadWay'
import CollectDialog from './collectDialog'
import Share from '@/components/share/gre'
import { TAG_COLOR_MAP } from '@/database/tagColor'

import { 
  apiWebCollect,
  apiWebDelCollect,
  apiGetVoiceList,
  apiGetVoice,
  apiGetFavorateVoice,
 } from '@/api/api.js'

export default {
  components: {
    ModelSelect,
    ReportError,
    VideoDialog,
    ExercisesSubtitles,
    PracticeContent,
    // WalkmanPracticeContent,
    GreContent,
    PassDialog,
    AskQuestions,
    Button,
    Audio,
    LeadWay,
    SubmutBtn,
    Func,
    VipCount,
    CollectDialog,
    Share
  },
  props: {
    id: {
      type: [Number, String]
    },
    detail: {
      type: Object,
      default: () => {}
    },
    number: {
      type: Object,
      default: () => {}
    },
    idList: {
      type: Object,
      default: () => {}
    },
    isPractice: {
      type: Boolean
    },
    isJobType: {
      type: Boolean
    },
    typeInfo: {
      type: Object,
      default: () => {}
    },
    filters: {
      type: Object,
      default: () => {}
    },
    search: {
      type: Function,
      default: () => {}
    },
    isDetail: {
      type: String
    },
    claId: null,
    chapterId: null,
    loading: {
      type: Boolean
    },
    greId: {
      type: [Number, String]
    },
    saveSuccess: {
      type: Function,
      default: () => {}
    },
    startRecorder: {
      type: Function,
      default: () => {}
    },
    currentIndex: {
      type: Number
    }
  },
  data() {
    return {
      checkList: [],
      showErrorDialog: false,
      showVideoDialog: false,
      showPassDialog: false,
      showSubtitles: false,
      collected: false,
      collectedLoading: false,
      checkOkButton: false,
      isSubmit: false,
      had_exam_cnt: 0,
      submitLoading: false,
      colorMap: TAG_COLOR_MAP,

      showAskDialog: false,
      playbackRate: '', // 默认播放速度为1x
      playbackRateOptions: [
        { value: '0.5', label: '0.5x' },
        { value: '0.75', label: '0.75x' },
        { value: '1', label: '1x' },
        { value: '1.25', label: '1.25x' },
        { value: '1.5', label: '1.5x' },
        { value: '2', label: '2x' }
      ],
      voice: '',
      voiceOptions: [],
      dialogVisible: false, // 控制弹窗显示的变量
      job_end_time: sessionStorage.getItem('job_end_time'),
      isExpired: false
    }
  },
  watch: {
    detail: {
      immediate: true,
      handler(val) {
        this.collected = Object.keys(this.detail.collect_cate).length > 0
        this.checkOkButton = this.isPractice ? !!val.has_exam : !!val.check
        this.showSubtitles = false
        this.submitLoading = false
        this.had_exam_cnt = this.detail.had_exam_cnt
      }
    }
  },
  computed: {
    showSubtitlesbtn() {
      // typeId
      //   ['RL', 'SST', 'MCM', 'MCS', 'SMW', 'HCS'].includes(this.typeInfo.type)
      return (
        this.isPractice &&
        [39, 28, 29, 32, 33, 31, 54, 55].includes(this.typeInfo.typeId)
      )
    },
    i18n() {
      return this.$t('messages')
    },
    hideTitle() {
      return ['RS', 'ASQ', 'WFD'].includes(this.typeInfo.type)
    }
  },
  methods: {
    handleSubmitLoading(val) {
      this.submitLoading = val
    },
    handleSubmit(val) {
      this.isSubmit = val
    },
    submit() {
      this.$refs.practice.submitQuestion()
    },
    handleAskDialog() {
      this.showAskDialog = !this.showAskDialog
    },
    handleErrorDialog() {
      this.showErrorDialog = !this.showErrorDialog
    },
    handleVideoDialog() {
      this.showVideoDialog = !this.showVideoDialog
    },
    handlePassDialog() {
      this.showPassDialog = !this.showPassDialog
    },
    handleSubtitles() {
      this.showSubtitles = !this.showSubtitles
    },
    // 更改播放速度
    changePlaybackRate() {
      this.$refs.audio.playbackRate = parseFloat(this.playbackRate);
    },
    changeVoice() {
      console.log("changeVoice")
      this.dialogVisible = true; // 显示弹窗
      apiGetVoice({
        ggid: this.greId,
        voiceId: this.voice
      })
      .then((res) => {
        this.dialogVisible = false; // 显示弹窗

        if (res.code != 200) {
          console.log(res.data);
          return;
        }
        if(this.voice == '0000'){
          this.$refs.practice.$refs.audioToolRef.audioUrl = this.detail.audio.url;
        }else{
          this.$refs.practice.$refs.audioToolRef.audioUrl = res.data.url;
        }
      })
      .finally(() => {
        // this.loading = false
        
      })
    },
    fetchVoiceOptoins() {
      console.log("fetchVoiceOptoins")
      apiGetVoiceList()
      .then((res) => {
        if (res.code != 200) {
          console.log(res.data);
          return;
        }
        console.log(res.data);
        this.voiceOptions = res.data.map(item => ({
          label: item.name+"("+item.description+")",  // 显示文本
          value: item.id,    // 实际值
        }));

        // 设置用户喜好声音
        if(this.$refs.practice?.$refs?.audioToolRef?.audioUrl){
          apiGetFavorateVoice()
          .then((res) => {
            if (res.code != 200) {
              console.log(res.data);
              return;
            }
            console.log("设置用户喜好声音");
            console.log(res.data.voiceId);
            if(res.data.voiceId){
              this.voice = res.data.voiceId;
              this.changeVoice();
              console.log("设置成功");
            }
          })
        }
        
      })
      .finally(() => {
        // this.loading = false
        
      })
    },
    selectItem(type) {
      this.$emit('selectItem', type)
    },
    handleCheckOk() {
      this.had_exam_cnt = this.had_exam_cnt + 1
      this.checkOkButton = true
      this.$layer.msg("<div class='success-icon'></div><div>确认考过成功</div>")
    },
    handleCollect() {
      this.$refs.collect.open()

      // if (this.collectedLoading) {
      //   return
      // }
      // this.collectedLoading = true
      // if (this.collected) {
      //   apiWebDelCollect({
      //     aid: this.idList.current,
      //     paramerid: this.idList.current,
      //     type: this.isPractice ? 'practice' : 'gremat'
      //   })
      //     .then((res) => {
      //       if (res.code != 200) {
      //         return
      //       }
      //       this.$layer.msg(
      //         "<div class='success-icon'></div><div>已取消收藏</div>"
      //       )
      //       this.collected = !this.collected
      //     })
      //     .finally(() => {
      //       this.collectedLoading = false
      //     })
      // } else {
      //   apiWebCollect({
      //     aid: this.idList.current,
      //     paramerid: this.idList.current,
      //     type: this.isPractice ? 'practice' : 'gremat'
      //   })
      //     .then((res) => {
      //       if (res.code != 200) {
      //         return
      //       }
      //       this.$layer.msg("<div class='success-icon'></div><div>已收藏</div>")
      //       this.collected = !this.collected
      //     })
      //     .finally(() => {
      //       this.collectedLoading = false
      //     })
      // }
    },
    handleFuncChange(type, value) {
      if (this.$refs.practice) {
        this.$refs.practice.setFuncValue(type, value)
      }
    },
    handleShare() {
      this.$refs.share.open(this.detail)
    },
    handleAudioEnd(type) {
      this.$emit('selectItem', type)
    }
  },
  mounted() {
    // 切换喜好语音，只支持rs和wfd
    if(['RS', 'WFD'].includes(this.typeInfo.type)){
      this.fetchVoiceOptoins(); // 组件加载时获取数据
    }
    this.isExpired = new Date() > new Date(this.job_end_time)
  },
}
